import React from "react";
import FormLabel from "./styled/FormLabel";
import DocumentCard from "./styled/DocumentCard";
import CertificateDocumentUploader from "./styled/CertificateDocumentUploader";
import FormLabelDescription from "./styled/FormLabelDescription";

const CertificateForm = ({
  certificates,
  handleCertificateChange,
  handleCertificateDelete,
  loadingCertificate,
}) => {
  return (
    <>
      <FormLabel>Adjuntar Certificados</FormLabel>
      <FormLabelDescription>
        Puede adjuntar todos los certificados que posee.
      </FormLabelDescription>
      {certificates.map((certificate, index) => (
        <DocumentCard
          key={index}
          imageUrl={URL.createObjectURL(certificate)}
          onDelete={() => handleCertificateDelete(index)}
        />
      ))}
      <CertificateDocumentUploader
        onCertificateChange={(file) => handleCertificateChange(file)}
        loading={loadingCertificate}
      />
    </>
  );
};

export default CertificateForm;
